var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLimeGreenEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5643 5.69609C22.7395 5.55684 23 5.68711 23 5.90723V15.0938C23 16.2842 22.0342 17.25 20.8438 17.25H2.15625C0.96582 17.25 0 16.2842 0 15.0938V5.91172C0 5.68711 0.256055 5.56133 0.435742 5.70059C1.44199 6.48223 2.77617 7.475 7.3582 10.8037C8.30606 11.4955 9.90527 12.951 11.5 12.942C13.1037 12.9555 14.7344 11.4686 15.6463 10.8037C20.2283 7.475 21.558 6.47773 22.5643 5.69609ZM11.5 11.5C12.5422 11.518 14.0426 10.1883 14.7973 9.64023C20.7584 5.31426 21.2121 4.93691 22.5867 3.85879C22.8473 3.65664 23 3.34219 23 3.00977V2.15625C23 0.96582 22.0342 0 20.8438 0H2.15625C0.96582 0 0 0.96582 0 2.15625V3.00977C0 3.34219 0.152734 3.65215 0.413281 3.85879C1.78789 4.93242 2.2416 5.31426 8.20273 9.64023C8.95742 10.1883 10.4578 11.518 11.5 11.5Z",
    fill: "#B2D236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimeGreenEnvelope);
export default __webpack_public_path__ + "static/media/LimeGreenEnvelope.5375919244b99e81d3afd8d6c1ad1fb0.svg";
export { ForwardRef as ReactComponent };